<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="top">
          <div class="top-item">
            <span>筛选条件</span>
            <el-input
              placeholder="电话或订单号"
              v-model.trim="orderCondition"
              clearable
              size="small"
            ></el-input>
          </div>
          <div class="top-item">
            <span>时间选择</span>
            <el-date-picker
              v-model="orderTime"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              size="small"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
          <div class="top-item">
            <el-button type="primary" size="small" @click="screenOrder">筛选</el-button>
            <el-button @click="resetScreenData" size="small">重置</el-button>
            <el-button @click="exportData" size="small">导出订单</el-button>
          </div>
        </div>
      </div>
      <div class="tab-content">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane
            v-for="item in orderClassifyList"
            :key="String(item.orderStatus)"
            :label="String(item.orderNum)"
            :name="String(item.orderStatus)"
          >
            <span slot="label">
              <span>{{ item.orderStatusName }}</span>
              <el-badge
                v-if="
                  item.orderNum &&
                  (item.orderStatus == -21 ||
                    item.orderStatus == 10 ||
                    item.orderStatus == 20)
                "
                :value="item.orderNum"
                class="item"
              ></el-badge>
            </span>
          </el-tab-pane>
        </el-tabs>
        <div class="list" v-loading="isLoad">
          <div class="order-list" v-if="orderList.length">
            <ul>
              <li v-for="(item, index) in orderList" :key="item.tradeNo">
                <div class="item">
                  <div class="list-header">
                    <span class="order-num">#{{ item.orderNum }}</span>
                    <span class="delivery-time">{{ item.deliveryTime }}</span>
                    <!-- <span class="suggest">建议12:19送达</span> -->
                    <span class="order-no">
                      订单号：{{ item.tradeNo }}
                      <input
                        style="position: absolute; top: 0; left: 0"
                        :value="item.tradeNo"
                        :class="`order-no${index}`"
                      />
                    </span>
                    <el-button type="text" @click="copyOrderNo(index)">复制</el-button>
                  </div>
                  <div class="list-container">
                    <div class="products">
                      <div
                        v-for="(product, productIndex) in item.productsOem"
                        :key="productIndex"
                      >
                        <div
                          class="products-item"
                          v-for="(productItem, itemIndex) in product"
                          :key="itemIndex"
                        >
                          <div class="info">
                            <img :src="productItem.goodsImage" alt />
                            <div>
                              <p class="name" :title="productItem.goodsName">
                                {{ productItem.goodsName }}
                              </p>
                              <p
                                class="desc"
                                v-if="productItem.specDesc"
                                :title="productItem.specDesc"
                              >
                                （{{ productItem.specDesc }}）
                              </p>
                              <p class="price">
                                ￥{{ Number(productItem.retailPrice).toFixed(2) }}
                              </p>
                            </div>
                          </div>
                          <div class="num">
                            X{{ productItem.buyCount }}
                            <span
                              class="num-type"
                              :class="{
                                retreat: productItem.productSaleStatus == 1,
                                give: productItem.productSaleStatus == 4,
                              }"
                              v-if="
                                productItem.productSaleStatus == 1 ||
                                productItem.productSaleStatus == 4
                              "
                              >{{ productItem.productSaleStatus == 1 ? "退" : "赠"
                              }}{{ productItem.buyCount }}</span
                            >
                          </div>
                          <div class="price">
                            ￥{{ Number(productItem.totalRetailPrice).toFixed(2) }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="time">
                      <div class="time-item">
                        <p>预约时间：{{ item.deliveryTime }}</p>
                        <p>下单时间：{{ item.createTime }}</p>
                        <!-- <p>{{ timeTitleFormat(item.orderStatus) }}</p> -->
                        <!-- <p>{{ timeOrderFormat(item) }}</p> -->
                      </div>
                    </div>
                    <div class="info">
                      <div>
                        <p class="address">
                          {{ item.buyerName }} {{ item.buyerPhone }}
                          {{ item.buyerAddress }}
                        </p>
                      </div>
                      <p class="mark">备注：{{ item.buyerMark }}</p>
                    </div>
                    <div class="action" v-if="orderType[item.orderStatus]">
                      <p :class="orderType[item.orderStatus].class">
                        {{ orderType[item.orderStatus].title }}
                      </p>
                      <el-button
                        size="small"
                        type="primary"
                        v-if="orderType[item.orderStatus].btn"
                        @click="
                          handleOrder(
                            item.mallOrderId,
                            item.orderStatus,
                            item.totalRetailPrice,
                            item.entryType,
                            item.orderCode
                          )
                        "
                        >{{ orderType[item.orderStatus].btn }}</el-button
                      >
                      <el-button
                        size="small"
                        type="primary"
                        v-if="item.orderStatus == -21"
                        @click="
                          handleOrder(
                            item.mallOrderId,
                            -21,
                            item.totalRetailPrice,
                            3,
                            item.orderCode
                          )
                        "
                        >完成</el-button
                      >
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-else>
            <div class="list-none">
              <p>暂无更多数据</p>
            </div>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAllOrders,
  getShopTables,
  getOrderNumsByStatus,
  operateOrder,
  handleOrder,
  printOrder,
  createReundOrder,
  getEdcShopGoodsCategorys,
  getEleOrderShipDetail,
  createEleOrder,
  getExpressCompany,
  sendDSOrder,
  orderExpress,
} from "@/api";
import takeoutPic from "@/assets/img/order/icon-takeout.png";
import tangPic from "@/assets/img/order/icon-tang.png";
import md5 from "js-md5";
import request from "@/utils/request";

let params = null;
let orderList = null;

export default {
  data() {
    return {
      takeoutPic: takeoutPic,
      tangPic: tangPic,
      pickupPic: require("@/assets/img/order/icon-pickup.png"),
      orderCondition: "",
      orderConditionPlaceholder: "",
      orderClassifyListBefore: [],
      orderClassifyList: [],
      activeName: "all",
      pageCount: 0,
      tablePositionValue: "all",
      tablePositionList: [
        {
          shoppingTableId: "all",
          tableName: "全部桌位",
        },
      ],
      orderCategory: "",
      orderTime: [],
      startDate: "",
      endDate: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      pageNo: 1,
      pageSize: 5,
      orderList: [],
      isLoad: false,
      orderType: {
        10: {
          title: "待付款",
          class: "black",
          // btn: "确认买单",
        },
        19: {
          title: "待接单",
          class: "red",
          //   btn: "确认接单",
        },
        20: {
          title: "待核销",
          class: "red",
          btn: "核销",
        },
        30: {
          title: "待确认",
          class: "black",
        },
        31: {
          title: "待买单",
          class: "black",
          //   btn: "确认买单",
        },
        35: {
          title: "待评论",
          class: "black",
        },
        40: {
          title: "已完成",
          class: "black",
          //   btn: "退款",
        },
        "-10": {
          title: "已关闭",
          class: "red",
        },
        "-20": {
          title: "已取消",
          class: "red",
        },
        "-21": {
          title: "申请退款",
          class: "red",
          btn: "原路返回",
        },
        "-50": {
          title: "退款",
          class: "black",
        },
      },
      isShowDiscountPop: false,
      discount: "",
      tagList: [],
      tagSelList: [],
      //是否显示蜂鸟快递信息弹窗
      isShowLogisticsInfo: false,
      logisticsInfoText: {
        1: {
          title: "商家已接单",
          desc: "商家已接单，等待骑手接单",
        },
        2: {
          title: "骑士正在赶往店内取货",
          desc: "骑士正在赶往店内取货，请提前备好商品",
        },
        3: {
          title: "骑士正在送货",
          desc: "骑士正在努力赶往收货地点",
        },
        4: {
          title: "商品已送达，订单已完成",
          desc: "感谢您对码点餐的信任，期待再次光临",
        },
        5: {
          title: "骑手取消订单",
          desc: "骑手取消订单",
        },
        7: {
          title: "订单已过期",
          desc: "订单已过期",
        },
        8: {
          title: "指派单",
          desc: "指派单",
        },
        9: {
          title: "配送异常",
          desc: "配送异常，骑手返回途中",
        },
        10: {
          title: "骑士正在店内取货",
          desc: "骑士取货后，订单自动变成已发货状态",
        },
        1000: {
          title: "创建运单失败",
          desc: "创建运单失败",
        },
      },
      logisticsInfo: {
        eleInfo: {
          delivery_info: {
            delivery_name: "毛晓松", //骑手姓名
            delivery_phone: "13587435597", //骑手电话
            delivery_party: "", //运力类型(汉字)
            delivery_longitude: "", //骑手经度
            delivery_latitude: "", //骑手纬度
          },
        },
        status: [
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 14:15:24",
            createTime: "2020-06-05 14:15:24",
            isDelete: 0,
            orderStatus: 1, ////订单状态(待接单＝1 待取货＝2 配送中＝3 已完成＝4 已取消＝5 已过期＝7 指派单=8 妥投异常之物品返回中=9  已到店=10（蜂鸟需要） 妥投异常之物品返回完成=10 创建达达运单失败=1000
            id: 79,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
        ],
      },
      //发货相关
      isShowDeliverGoodsPop: false,
      oddNumbers: "",
      expressCompanyList: [],
      sendCompanyId: "",
      mallOrderId: "",
    };
  },
  watch: {
    activeName(status) {
      console.log(status);
      this.orderClassifyList.forEach((val) => {
        if (val.orderStatus == status) {
          this.pageCount = val.orderNum;
        }
      });
      this.pageNo = 1;
      this.getPageData();
    },
    currentPage(v) {
      this.activeName = "all";
      this.getPageData();
    },
    orderTime(val) {
      this.startDate = val ? new Date(val[0]).pattern("yyyy-MM-dd") : "";
      this.endDate = val ? new Date(val[1]).pattern("yyyy-MM-dd") : "";
    },
    orderCondition(val) {
      if (!val.length) {
        this.getPageData();
      }
    },
    isShowDiscountPop(val) {
      if (!val) {
        this.discount = "";
        orderList = null;
        params = null;
      }
    },
  },
  computed: {
    // currentPage() {
    //   let path = this.$route.path;
    //   if (path == "/order/dsOrder") {
    //     this.orderCategory = 14;
    //   }
    //   if (path == "/order/takeout") {
    //     this.orderCategory = 3;
    //   }
    //   if (path == "/order/tang") {
    //     this.orderCategory = 5;
    //   }
    //   this.getOrderNumsByStatus();
    //   return path;
    // },
  },
  mounted() {
    if (this.$route.params.tradeNo) {
      this.orderCondition = this.$route.params.tradeNo;
    }
    this.getShopTables();
    this.getPageData();
    this.getEdcShopGoodsCategorys();
  },
  methods: {
    exportData() {
      let activeName = this.activeName == "all" ? "" : this.activeName;
      if (!this.startDate || !this.endDate) {
        this.$notify.warning("请选择日期");
        return;
      }
      location.href = `${request.baseUrl}/edcmanageapi/Order_exportOrder?userId=${localStorage.userId}&sessionId=${localStorage.sessionId}&orderStatus=${activeName}&orderCategorys=6&startDate=${this.startDate}&endDate=${this.endDate}`;
    },
    getPageData() {
      this.getAllOrders();
      //   this.getExpressCompany();
      this.getOrderNumsByStatus();
    },
    getEdcShopGoodsCategorys() {
      getEdcShopGoodsCategorys({
        pageNo: this.pageNo,
        row: 9999,
      }).then((res) => {
        if (res.code == 1) {
          this.tagSelList = [];
          res.data.forEach((val) => {
            this.tagSelList.push(val.goodsCategoryId);
          });
          this.tagList = res.data;
        } else {
          this.tagList = [];
        }
      });
    },
    getOrderNumsByStatus(cb) {
      getOrderNumsByStatus({
        orderCategorys: 6,
        // orderCategory: this.orderCategory,
        startDate: this.startDate,
        endDate: this.endDate,
        shoppingTableId: this.tablePositionValue == "all" ? "" : this.tablePositionValue,
        keyWord: this.orderCondition,
      }).then((res) => {
        if (res.code == 1) {
          this.orderClassifyListBefore = res.data;
          let path = this.$route.path;
          let list = [];
          let orderClassifyList = [];
          orderClassifyList = [
            {
              orderStatusName: "全部订单",
              orderNum: 0,
              orderStatus: "all",
            },
            {
              orderStatusName: "未付款",
              orderNum: 0,
              orderStatus: 10,
            },
            {
              orderStatusName: "待核销",
              orderNum: 0,
              orderStatus: 20,
            },
            {
              orderStatusName: "待评论",
              orderNum: 0,
              orderStatus: 35,
            },
            {
              orderStatusName: "已完成",
              orderNum: 0,
              orderStatus: 40,
            },
            {
              orderStatusName: "申请退款",
              orderNum: 0,
              orderStatus: -21,
            },
          ];
          orderClassifyList.forEach((val) => {
            this.orderClassifyListBefore.forEach((subval) => {
              if (val.orderStatus == subval.orderStatus) {
                val.orderNum = subval.orderNum;
              }
            });
            list.push(val);
          });
          list.forEach((val) => {
            if (val.orderStatus == this.activeName) {
              this.pageCount = val.orderNum;
            }
          });
          this.orderClassifyList = list;
        }
      });
    },
    getAllOrders() {
      this.isLoad = true;
      getAllOrders({
        pageNo: this.pageNo,
        row: this.pageSize,
        orderStatus: this.activeName == "all" ? "" : this.activeName,
        orderCategorys: 6,
        shoppingTableId: this.tablePositionValue == "all" ? "" : this.tablePositionValue,
        startDate: this.startDate,
        endDate: this.endDate,
        keyWord: this.orderCondition,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val, index) => {
            val.productsOem = [];
            val.products.forEach((proVal, proIndex) => {
              if (val.productsOem[proVal.groupId] == undefined) {
                val.productsOem[proVal.groupId] = [];
                val.productsOem[proVal.groupId].push(proVal);
              } else {
                val.productsOem[proVal.groupId].push(proVal);
              }
              if (proIndex == val.products.length - 1) {
                var r = val.productsOem.filter(function (s) {
                  return s;
                });
                val.productsOem = r;
                val.productsOem.reverse();
              }
            });
          });
          this.orderList = res.data;
          console.log(this.orderList);
          if (this.$route.params.tradeNo && this.orderCondition) {
            this.pageCount = res.data.length;
          }
        }
        if (res.code == -1) {
          this.orderList = [];
        }
        this.isLoad = false;
      });
    },
    getShopTables() {
      getShopTables({
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          this.tablePositionList.push(...res.data);
        }
      });
    },
    resetScreenData() {
      this.pageNo = 1;
      this.tablePositionValue = "all";
      this.orderTime = [];
      this.startDate = "";
      this.endDate = "";
      this.orderCondition = "";
      this.getPageData();
    },
    screenOrder() {
      this.pageNo = 1;
      this.getPageData();
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getPageData();
    },
    handleOrder(mallOrderId, orderStatus, payMoney, entryType, orderCode) {
      console.log(orderCode);
      let nextOrderStatus = 0;
      if (orderStatus == 19) {
        nextOrderStatus = 20;
      }
      if (orderStatus == 20) {
        nextOrderStatus = 35;
        this.$prompt("请输入核销码", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputType: "number",
        }).then(({ value }) => {
          console.log(value);
          if (orderCode == value) {
            this.handleOrderFuc(mallOrderId, nextOrderStatus);
            // createReundOrder({
            //   mallOrderId: mallOrderId,
            // }).then((res) => {
            //   if (res.code == 1) {
            //     this.$notify({
            //       title: "提示",
            //       message: "核销成功",
            //       type: "success",
            //       duration: 1000,
            //     });

            //   }
            // });
          } else {
            this.$notify({
              title: "提示",
              message: "请输入正确的核销码",
              type: "error",
              duration: 2000,
            });
          }
        });
        return;
      }
      if (orderStatus == 31) {
        nextOrderStatus = 40;
      }
      if (orderStatus == 10) {
        nextOrderStatus = 20;
      }
      if (orderStatus == 40 || orderStatus == -21) {
        nextOrderStatus = -50;
        if (entryType != 3 && entryType != 4) {
          this.$prompt("请输入密码", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputType: "password",
          }).then(({ value }) => {
            createReundOrder({
              managerPassWord: String(md5(value)).toUpperCase(),
              mallOrderId: mallOrderId,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "退款成功",
                  type: "success",
                  duration: 1000,
                });
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
          });
          return;
        }
      }
      this.handleOrderFuc(mallOrderId, nextOrderStatus);
    },
    handleOrderFuc(mallOrderId, nextOrderStatus) {
      // return;
      handleOrder({
        mallOrderId: mallOrderId,
        orderStatus: nextOrderStatus,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "操作成功",
            type: "success",
            duration: 1000,
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    // operateOrder(params) {
    //   operateOrder(params).then((res) => {
    //     if (res.code == 1) {
    //       this.$notify({
    //         title: "提示",
    //         message: "操作成功",
    //         type: "success",
    //         duration: 1000,
    //       });
    //       this.getPageData();
    //     } else {
    //       this.$notify({
    //         title: "提示",
    //         message: res.msg,
    //         type: "error",
    //         duration: 2000,
    //       });
    //     }
    //   });
    // },
    // 复制订单号
    copyOrderNo(index) {
      var copyText = document.querySelector(`.order-no${index}`);
      copyText.select();
      document.execCommand("copy");
      this.$notify({
        title: "提示",
        message: "复制成功",
        type: "success",
        duration: 1000,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
  }
  .tab-header {
    .top {
      display: flex;
      .top-item {
        display: flex;
        flex: 1;
        align-items: center;
        margin-right: 66px;
        span {
          white-space: nowrap;
          margin-right: 10px;
          font-size: 12px;
          color: #333333;
          font-weight: bold;
        }
        .el-select {
          width: 100%;
        }
      }
    }
  }
  .tab-content {
    display: block;
    padding: 20px;
    .order-list {
      .item {
        border: 1px solid #eeeeee;
        margin-bottom: 20px;
        .list-header {
          background: #f8f8f8;
          height: 48px;
          line-height: 48px;
          padding-left: 18px;
          .order-num {
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            margin-right: 10px;
          }
          .delivery-time {
            font-size: 12px;
            color: #f57878;
            margin-right: 10px;
          }
          .suggest,
          .order-no {
            font-size: 12px;
            color: #666666;
          }
          .suggest {
            margin-right: 28px;
          }
          .order-no {
            margin-right: 10px;
          }
        }
        .list-container {
          display: flex;
          & > div {
            border-right: 1px solid #eee;
            &:last-child {
              border-right: 0;
            }
          }
          .products {
            flex: 3.63;
            & > div:last-of-type {
              & > .products-item:last-of-type {
                border-bottom: 0;
              }
            }
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            & > div {
              width: 100%;
            }
            .products-item {
              display: flex;
              height: 70px;
              box-sizing: border-box;
              align-items: center;
              border-bottom: 1px solid #eee;
              .info {
                flex: 5.3;
                display: flex;
                align-items: center;
                img {
                  width: 50px;
                  height: 50px;
                  margin: 0 10px 0 18px;
                }
                .price {
                  font-size: 12px;
                  line-height: 26px;
                  color: #666666;
                }
                .name {
                  font-size: 12px;
                  line-height: 28px;
                  color: #333333;
                  font-weight: bold;
                  white-space: nowrap;
                  max-width: 130px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
                .desc {
                  font-size: 12px;
                  line-height: 16px;
                  color: #666;
                  font-weight: bold;
                  white-space: nowrap;
                  max-width: 130px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }
              .num {
                flex: 1.46;
                font-size: 12px;
                color: #333333;
                font-weight: bold;
                .num-type {
                  display: inline-block;
                  border: 1px solid;
                  border-radius: 4px;
                  text-align: center;
                  font-size: 12px;
                  line-height: 22px;
                  box-sizing: border-box;
                  width: 36px;
                  height: 24px;
                  &.retreat {
                    border-color: #fde2e2;
                    background-color: #fef0f0;
                    color: #f57878;
                  }
                  &.give {
                    border-color: #faecd8;
                    background-color: #fdf6ec;
                    color: #e6a45d;
                  }
                }
              }
              .price {
                flex: 2.11;
                width: 130px;
                font-size: 12px;
                color: #666666;
              }
              .action {
                flex: 1.11;
              }
            }
          }
          .time {
            flex: 0.87;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .time-item {
              font-size: 12px;
              color: #999999;
              line-height: 22px;
            }
          }
          & > .info {
            position: relative;
            flex: 1.95;
            padding: 32px 10px 10px 15px;
            font-size: 14px;
            line-height: 1;
            .takeoutinfo {
              margin-bottom: 14px;
            }
            .address {
              margin-bottom: 24px;
            }
            .tanginfo {
              color: #333333;
              .position {
                font-weight: bold;
              }
              margin-bottom: 20px;
            }
            .mark {
              color: #ee3030;
            }
            .icon-img {
              position: absolute;
              right: 10px;
              top: 10px;
            }
          }
          & > .price {
            flex: 1.58;
            text-align: center;
            padding-top: 31px;
            padding-bottom: 20px;
            line-height: 1;
            font-size: 14px;
            & > p:nth-of-type(1) {
              color: #333333;
              font-weight: bold;
              margin-bottom: 15px;
            }
            & > p:nth-of-type(2) {
              font-size: 12px;
              color: #999999;
              margin-bottom: 12px;
            }
            & > p:nth-of-type(3) {
              color: #ee3030;
              margin-bottom: 20px;
            }
          }
          .action {
            text-align: center;
            padding-top: 30px;
            padding-bottom: 20px;
            flex: 1;
            & > p:nth-of-type(1) {
              font-size: 14px;
              font-weight: bold;
              &.red {
                color: #ee3030;
              }
              &.black {
                color: #000;
              }
            }
            & > .el-button--primary {
              margin-top: 15px;
            }
            .el-button + .el-button {
              &.create-btn {
                display: block;
                margin-left: 0;
                margin: 10px auto 0;
              }
              margin-left: 2px;
            }
            .status-btn {
              display: block;
              margin-left: 0;
              margin: 10px auto 0;
            }
          }
          .print {
            text-align: center;
            padding-top: 20px;
            flex: 1;
            .check-logistics {
              display: block;
              margin: 10px auto 0;
            }
          }
        }
      }
    }
    .list-none {
      text-align: center;
      font-size: 14px;
      color: #999999;
      padding-top: 20px;
    }
  }
  .el-dialog {
    .el-select {
      width: 100%;
    }
  }
}
</style>

<style lang="less">
.el-transfer-panel__item {
  display: block;
}
.el-select-dropdown {
  width: 150px;
}
</style>
